import { useParams } from "react-router-dom";
import { HouseholdAssetsExpress } from "src/sections/dashboard/overview/household-assets-express";
import { usePageView } from "src/hooks/use-page-view";
import useHousehold, { ExperienceFlag } from "src/contexts/household-context";

export default function AssetsPage(): JSX.Element {
  const { ud_id } = useParams();
  const { experienceFlag } = useHousehold();

  usePageView();

  return (
    <>
      <HouseholdAssetsExpress
        express={false}
        readOnly={experienceFlag === ExperienceFlag.READONLY}
        triggerConfetti={undefined}
        setViewMode={undefined}
        personUdId={ud_id || null}
      />
    </>
  );
}
